import 'slick-carousel';

export default {
  init() {
    $(document).ready(function() {

      // TOGGLE POUR AFFICHAGE DE L'EXCERPT DES COMPETENCES
            $('.skills-carousel').slick({
              slidesToShow: 4,
              slidesToScroll: 1,
              arrows: false,
              autoplay: false,
              responsive: [
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  },
                },
              ],
            });
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/home.js